export default import.meta.ROLLDOWN_FILE_URL_QpSHCVdm6C55TUBZK905xw